import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=f9c5eedc&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9c5eedc')) {
      api.createRecord('f9c5eedc', component.options)
    } else {
      api.reload('f9c5eedc', component.options)
    }
    module.hot.accept("./Error500.vue?vue&type=template&id=f9c5eedc&", function () {
      api.rerender('f9c5eedc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Error500.vue"
export default component.exports